import axios from 'axios';

// Worker API base URL
const API_BASE_URL = import.meta.env.VITE_API_URL || 'https://auth-worker.manishmlv50.workers.dev';

// Create axios instance
const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// API methods
export const api = {
  // Create a new login request
  createLoginRequest: async () => {
    try {
      const response = await apiClient.post('/login-request');
      return response.data;
    } catch (error) {
      console.error('Error creating login request:', error);
      throw error;
    }
  },

  // Check the status of a login request
  checkLoginStatus: async (requestId: string) => {
    try {
      const response = await apiClient.get(`/login-status?requestId=${requestId}`);
      return response.data;
    } catch (error) {
      console.error('Error checking login status:', error);
      throw error;
    }
  },

  // Complete login after Google authentication
  completeLogin: async (requestId: string, userId: string, name: string, email: string, picture: string) => {
    try {
      const response = await apiClient.post('/complete-login', {
        requestId,
        userId,
        email,
        name,
        picture,
      });
      return response.data;
    } catch (error) {
      console.error('Error completing login:', error);
      throw error;
    }
  },

  // Validate the authentication token
  validateToken: async (token: string) => {
    try {
      const response = await apiClient.post('/validate-token', {
        token,
      });
      return response.data;
    } catch (error) {
      console.error('Error validating token:', error);
      throw error;
    }
  },

  // Check if a login request is valid
  checkLoginRequest: async (requestId: string) => {
    try {
      const response = await apiClient.get(`/check-login-request?requestId=${requestId}`);
      return response.data;
    } catch (error) {
      console.error('Error checking login request:', error);
      throw error;
    }
  },
}; 